import {
  fade,
  makeStyles,
  // Theme,
  createStyles,
} from '@material-ui/core/styles';
// import { Colors } from '../../../styles';
import Configuration from './configuration';
import { SideBarWidth } from 'config';

const drawerWidth = SideBarWidth;

const useStyles = makeStyles((theme?: any) =>
  createStyles({
    root: {
      display: 'flex',
    },
    grow: {
      flexGrow: 1,
    },
    appBar: {
      boxShadow: '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.05)',
      transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      [theme.breakpoints.up('sm')]: {
        zIndex: theme.zIndex.drawer + 1, //temp
      },
    },
    appBarShift: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
      transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    menuButton: {
      marginRight: theme.spacing(2),
    },
    hide: {
      display: 'none',
    },
    drawer: {
      width: drawerWidth,
      flexShrink: 0,
    },
    drawerPaper: {
      borderRight: '0 !important',
      width: '100vw',
      // backgroundColor: Configuration.sidebar.config?.color || 'white',
      // position: 'fixed',
      backgroundColor:
        Configuration.sidebar.config?.sidebarColorBack || 'transparent',
      [theme.breakpoints.up('sm')]: {
        width: drawerWidth,
        // position: 'fixed',
      },
    },
    drawerHeader: {
      display: 'flex',
      alignItems: 'center',
      padding: theme.spacing(0, 1),
      // necessary for content to be below app bar
      ...theme.mixins.toolbar,
      justifyContent: 'flex-end',
    },
    content: {
      flexGrow: 1,
      overflow: 'auto',
      // padding: theme.spacing(2),
      transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      marginLeft: -drawerWidth,
    },
    contentShift: {
      transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 0,
    },
    sectionDesktop: {
      display: 'none',
      [theme.breakpoints.up('sm')]: {
        display: 'flex',
      },
    },
    sectionMobile: {
      display: 'flex',
      [theme.breakpoints.up('sm')]: {
        display: 'none',
      },
    },
    searchIcon: {
      padding: theme.spacing(0, 2),
      height: '100%',
      position: 'absolute',
      pointerEvents: 'none',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    inputRoot: {
      color: 'inherit',
    },
    inputInput: {
      padding: theme.spacing(1, 1, 1, 0),
      // vertical padding + font size from searchIcon
      paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
      transition: theme.transitions.create('width'),
      width: '100%',
      [theme.breakpoints.up('md')]: {
        width: '20ch',
      },
    },
    search: {
      position: 'relative',
      borderRadius: theme.shape.borderRadius,
      backgroundColor: fade(theme.palette.common.white, 0.15),
      '&:hover': {
        // backgroundColor:
        backgroundColor: fade(theme.palette.common.white, 0.25),
      },
      marginRight: theme.spacing(2),
      marginLeft: 0,
      width: '100%',
      [theme.breakpoints.up('sm')]: {
        marginLeft: theme.spacing(3),
        width: 'auto',
      },
    },
    title: {
      display: 'none',
      [theme.breakpoints.up('sm')]: {
        display: 'block',
      },
    },
    avatar: {
      cursor: 'pointer',
      width: 50,
      height: 50,
      padding: 4,
      backgroundColor: Configuration.sidebar.config?.secondaryColor,
    },
    drawerListItemText: {
      color: Configuration.sidebar.config?.listSelectedItemTextColor,
    },
    drawerListItemTextSelected: {
      color: Configuration.sidebar.config?.listSelectedItemTextColorSelected,
    },
    drawerSelectedItem: {
      width: '97%',
      backgroundColor: Configuration.sidebar.config?.listSelectedItemColor,
      '&:hover': {
        backgroundColor:
          Configuration.sidebar.config?.listSelectedItemColorHover,
      },
      borderBottomRightRadius: 50,
      borderTopRightRadius: 50,
      marginBottom: 2,
    },
    drawerUnselectedItem: {
      width: '97%',
      '&:hover': {
        backgroundColor:
          Configuration.sidebar.config?.listUnelectedItemColorHover,
      },
      borderBottomRightRadius: 50,
      borderTopRightRadius: 50,
      marginBottom: 2,
    },
    expand: {
      transform: 'rotate(0deg)',
      marginLeft: 'auto',
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
      }),
      color: Configuration.sidebar.config?.primaryTextColor,
    },
    expandOpen: {
      transform: 'rotate(180deg)',
    },
    subElement: {
      cursor: 'pointer',
      color: Configuration.sidebar.config?.primaryTextColor,
      paddingLeft: 20,
      marginLeft: 5,
    },
  })
);

export default useStyles;
